var map = {
	"./actions-tray/feature": [
		25954,
		5954
	],
	"./assets/feature": [
		85284,
		5284
	],
	"./batching/feature": [
		60838,
		838
	],
	"./counterfactual/feature": [
		62767,
		7838,
		7751,
		6804,
		7132,
		9587,
		5180,
		4601,
		7147,
		3390,
		4180,
		8752,
		565,
		2767
	],
	"./global-search/feature": [
		97802,
		7802
	],
	"./gtf/feature": [
		15048,
		8463,
		5048
	],
	"./hypernative/feature": [
		75380,
		7838,
		6804,
		5180,
		7147,
		7935
	],
	"./ledger/feature": [
		5672,
		3291
	],
	"./myAccounts/feature": [
		41903,
		1099,
		148,
		142,
		8408,
		1903
	],
	"./nfts/feature": [
		35369,
		7751,
		9484,
		1707,
		5369
	],
	"./no-fee-campaign/feature": [
		41065,
		5729,
		1065
	],
	"./oidc-auth/feature": [
		67990,
		7990
	],
	"./portfolio/feature": [
		22396,
		5815,
		2396
	],
	"./recovery/feature": [
		88101,
		5363,
		7838,
		7751,
		6804,
		7132,
		7848,
		5223,
		5180,
		4601,
		9607,
		2253,
		926,
		7335
	],
	"./safenet-checks/feature": [
		81367,
		6804,
		5180,
		4601,
		78
	],
	"./security/feature": [
		12903,
		5125,
		2903
	],
	"./spaces/feature": [
		42135,
		8108,
		7132,
		148,
		5909,
		5766,
		5125,
		2135
	],
	"./speedup/feature": [
		78990,
		7838,
		8990
	],
	"./spending-limits/feature": [
		13299,
		7751,
		7838,
		6804,
		7132,
		9587,
		7848,
		5180,
		4601,
		7147,
		3390,
		9607,
		4180,
		2253,
		926,
		8752,
		8514,
		4257,
		3299
	],
	"./stake/feature": [
		75148,
		8955,
		5148
	],
	"./support-chat/feature": [
		41029,
		1029
	],
	"./swap/feature": [
		36214,
		2148,
		6214
	],
	"./targeted-features/feature": [
		52814,
		2814
	],
	"./targeted-outreach/feature": [
		54969,
		3790,
		4969
	],
	"./transactions/feature": [
		50374,
		5363,
		374
	],
	"./tx-notes/feature": [
		82137,
		4518
	],
	"./wallet/feature": [
		31172,
		8295,
		1172
	],
	"./walletconnect/feature": [
		88481,
		1520,
		5424,
		7884,
		8481
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73061;
module.exports = webpackAsyncContext;